import { render } from "./Dashboard.vue?vue&type=template&id=27ef36a9"
import script from "./Dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Insights/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27ef36a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27ef36a9', __exports__)) {
    api.reload('27ef36a9', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=27ef36a9", () => {
    api.rerender('27ef36a9', render)
  })

}


export default __exports__